import React, { useState } from 'react';
import { cn } from '../../lib/utils';

const Switch = React.forwardRef(({ className, checked, defaultChecked, onCheckedChange, disabled, ...props }, ref) => {
  const [isInternalChecked, setIsInternalChecked] = useState(defaultChecked || false);
  const isControlled = checked !== undefined;
  const isOn = isControlled ? checked : isInternalChecked;

  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled) {
      const newValue = !isOn;
      if (!isControlled) {
        setIsInternalChecked(newValue);
      }
      onCheckedChange?.(newValue);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-disabled={disabled}
      data-state={isOn ? "checked" : "unchecked"}
      className={cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        isOn
          ? "bg-primary border-primary"
          : "bg-muted border-muted-foreground/20",
        className
      )}
      ref={ref}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      <span
        className={cn(
          "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-transform -translate-y-px",
          isOn ? "translate-x-5" : "translate-x-0"
        )}
      />
    </button>
  );
});

Switch.displayName = 'Switch';

export { Switch };
